var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleSword(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.286 10.055l2.651 2.652-1.06 1.06 1.062 1.061-1.061 1.061-1.856-1.856-2.121 2.121-1.061-1.06 2.121-2.122-1.856-1.856 1.06-1.06 1.061 1.06 1.06-1.061zM2.25 2.25l2.66.003 8.863 8.863 1.06-1.06 1.062 1.06-1.857 1.856 2.122 2.121-1.06 1.061-2.122-2.121-1.856 1.856-1.061-1.06 1.06-1.062-8.869-8.869L2.25 2.25zm10.843 0l2.657.003.002 2.642-3.04 3.039-2.652-2.652 3.033-3.032z",
    fill: "#5C5C8E"
  })));
}
export default __webpack_public_path__ + "static/svg/double-sword.svg";
export { SvgDoubleSword as ReactComponent };